// extracted by mini-css-extract-plugin
export var generalJumbotronSection = "GeneralJumbotron-module--generalJumbotronSection--2WN8n";
export var contentWrapper = "GeneralJumbotron-module--contentWrapper--2h1KA";
export var title = "GeneralJumbotron-module--title--1xyQ8";
export var backgroundTitle = "GeneralJumbotron-module--backgroundTitle--e_CdN";